import { useStaticListSource, DictionaryAutocomplete } from '@eas/common-web';

export function useTypes() {
  return useStaticListSource<DictionaryAutocomplete>([
    { id: 'PLANNED', name: 'Plánovaná' },
    { id: 'OUTAGE', name: 'Výpadek' },
  ]);
}
